module.exports = __webpack_public_path__ + "img/link.cfaf0be8.svg";